import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

/** Matches the on-screen keyboard's slide-in, so the scroll lands after the viewport has shrunk. */
const KEYBOARD_SETTLE_MS = 300;

/**
 * Bottom-sheet shown on the check-up report page when a user answers a
 * feedback question with "No". Collects a free-text message and hands it back
 * to the opener via `data.onSubmit`, which persists it against the question key.
 */
@Component({
  selector: 'app-report-feedback-sheet',
  templateUrl: './report-feedback-sheet.html',
  standalone: false,
})
export class ReportFeedbackSheetComponent {
  feedbackValue: string = '';
  submitting: boolean = false;

  @ViewChild('feedbackInput') feedbackInput: ElementRef<HTMLTextAreaElement>;

  // eslint-disable-next-line new-cap
  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: { onSubmit: (message: string) => Promise<void> },
    private readonly bottomSheetRef: MatBottomSheetRef<ReportFeedbackSheetComponent>) {}

  /**
   * Keeps the textarea visible once the on-screen keyboard shrinks the viewport. The sheet is
   * anchored to the bottom of the screen, so without this the keyboard covers exactly what the
   * user is typing.
   */
  onInputFocus(): void {
    setTimeout((): void => {
      this.feedbackInput?.nativeElement?.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }, KEYBOARD_SETTLE_MS);
  }

  closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
  }

  async submit(): Promise<void> {
    const message = this.feedbackValue.trim();
    if (!message || this.submitting) return;
    this.submitting = true;
    try {
      await this.data.onSubmit(message);
      this.bottomSheetRef.dismiss(message);
    } finally {
      this.submitting = false;
    }
  }
}
